"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CalendarDay = void 0;
const mithril_1 = __importDefault(require("mithril"));
const app_1 = require("../app");
const auth_1 = require("../utils/auth");
const moment = require("moment");
class CalendarDay {
    constructor() {
        this.status = "idle";
        this._day = moment().tz("Europe/Paris");
    }
    get day() {
        return this._day;
    }
    set day(d) {
        this._day = d;
    }
    get venueId() {
        return this._venueId;
    }
    set venueId(v) {
        this._venueId = v;
        if (v) {
            this.fetch();
        }
    }
    getBooking(id) {
        let b = this.bookingIndex.get(`${id}`);
        if (!b) {
            throw new Error(`Booking not found: ${id}`);
        }
        return b;
    }
    moveBooking(booking, newRoom) {
        let bookingId = booking.details.id;
        let currentRoom = this.getRoomFromBookingId(bookingId);
        let idx = -1;
        currentRoom.bookings.find((value, index) => {
            idx = index;
            return !!((value.details) && value.details.id == bookingId);
        });
        currentRoom.bookings.splice(idx, 1);
        newRoom.bookings.push(booking);
        this.genIndices();
    }
    getRoomFromBookingId(id) {
        let r = this.roomReverseIndex.get(`${id}`);
        if (!r) {
            throw new Error(`Room not found for booking: ${id}`);
        }
        return r;
    }
    hasBooking(id) {
        return this.bookingIndex.has(`${id}`);
    }
    getPath() {
        return `/venues/${this.venueId}/bookings/${this.day.format("YYYYMMDD")}/show`;
    }
    genIndices() {
        this.bookingIndex = new Map();
        this.roomReverseIndex = new Map();
        this.data.rooms.forEach(room => {
            room.bookings.forEach(booking => {
                let details = booking.details;
                if (details) {
                    this.bookingIndex.set(`${details.id}`, booking);
                    this.roomReverseIndex.set(`${details.id}`, room);
                }
            });
        });
    }
    hasMeetingInTempZone() {
        let data = this.data;
        if (!data) {
            return false;
        }
        let tempRoom = data.rooms[0];
        return tempRoom.bookings.length > 0;
    }
    fetch() {
        this.bookingIndex = new Map();
        this.roomReverseIndex = new Map();
        if (this.data) {
            this.data.rooms.forEach(r => {
                r.bookings.length = 0;
            });
        }
        if (this.venueId === undefined)
            return;
        this.status = "idle";
        mithril_1.default.request({
            method: "GET",
            headers: { "X-Auth-Token": auth_1.Auth.token() },
            url: app_1.App.serviceURL(this.getPath()),
        })
            .then((data) => {
            const castedData = data;
            this.status = "loaded";
            this.data = castedData;
            this.genIndices();
        })
            .catch((error) => {
            if (error.code == 403 &&
                error.message == "unauthorized") {
                auth_1.Auth.logout();
            }
            else {
                this.status = "error";
                throw error;
            }
        });
    }
}
exports.CalendarDay = CalendarDay;
